export const FOOTER_BOTTOM_POINT = 'footer-bottom-point';

export const ITEM_SEARCH_TOP_BODY = 'item-search-top-body';
